/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Discord_LinkedInputs */



/**
* | output |
* | --- |
* | "Discord linked successfully!" |
*
* @param {Profile_Discord_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_discord_linked = /** @type {((inputs?: Profile_Discord_LinkedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Discord_LinkedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discord lié avec succès !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Discord vinculado exitosamente!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Discord vinculado com sucesso!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Discord collegato con successo!")
	return /** @type {LocalizedString} */ ("Discord linked successfully!")
});